import { Box, Container, CssBaseline } from "@mui/material";
import { Logo_Sage_Blue } from "@sagecentral/core-ui";
import { ReactNode } from "react";
import { Outlet } from "react-router-dom";

const AuthHelperUI: React.FC<{ children?: ReactNode }> = ({ children }) => (    
    <Container maxWidth={false} disableGutters sx={{ border: '0px', height: '90vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <Box sx={{ marginTop: '10px' }}>{Logo_Sage_Blue}</Box>
        <Box sx={{ marginTop: '10px', display: 'block' }}>
            {children ? children : <Outlet />}
        </Box>
    </Container>
);

export default AuthHelperUI;